import { render, staticRenderFns } from "./SeatingStyle.vue?vue&type=template&id=6f3e2b36&scoped=true&"
import script from "./SeatingStyle.vue?vue&type=script&lang=js&"
export * from "./SeatingStyle.vue?vue&type=script&lang=js&"
import style0 from "./SeatingStyle.vue?vue&type=style&index=0&id=6f3e2b36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3e2b36",
  null
  
)

export default component.exports